import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Installation } from 'src/app/model/incidents/pannes.model';
import { IncidentsService } from 'src/app/services/http/incidents/incidents.service';

@Component({
  selector: 'app-incidents-list',
  templateUrl: './incidents-list.component.html',
  styleUrls: ['./incidents-list.component.scss']
})
export class IncidentsListComponent implements OnInit {

  constructor(private service: IncidentsService, private builder: FormBuilder,) { }

  public isLoading: boolean = false;
  public installations!: Installation[];
  public total: number = 0;
  public tJour = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];
  public tMois = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
  public form !: FormGroup;
  public idList !: any[];
  public idArray: number[] = [];

  ngOnInit(): void {

    this.loadIncidentsDatas();

    this.form = this.builder.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });

  }

  /* GET all the incidents datas  */
  private loadIncidentsDatas() {
    this.isLoading = true;
    this.service.getIncidentsData()
      .subscribe((installations) => {
        this.installations = installations.installations;
       
        /** If list has to be filtered on concerned apd ids */
        if ( this.idArray.length > 0 ) {
          this.computeInstallations( this.idArray );
        } else {
          this.isLoading = false;
        }

        /** Update total accordingly to list size */
        this.updateTotal();
      });
  }

  /**
   * Update total number of incidents
   */
  private updateTotal(): void {
    this.total = 0;
    this.installations.forEach(element => {
      this.total += element.rg_pannes_non_traitees_headers.length;
    });
  }


  /**
   * Display date into human format
   */
  public convertDate(date: string): string {

    let newDate = Date.parse(date);
    let correctDate = new Date(newDate);
    return this.tJour[correctDate.getDay() - 1] + ' ' + correctDate.getDate() + ' ' + this.tMois[(correctDate.getMonth())] + ' ' + correctDate.getFullYear() + ' à ' + correctDate.getHours() + ':' + this.getCorrectMinuteDisplay(correctDate);
  }


  /**Shorten installation name */
  public shortInstallationName(nomInstall: string): string {
    if (nomInstall.length > 20) return nomInstall.slice(0, 20) + '...';
    else return nomInstall;
  }


  /**Enhance minutes display */
  public getCorrectMinuteDisplay(date: Date): any {
    if (date.getMinutes() < 10) return '0' + date.getMinutes();
    else return date.getMinutes();
  }


  public onSubmit() {
    this.filterIncidents();

  }

  public filterIncidents() {
    this.isLoading = true;
    this.idArray = [];
    this.service.getIdInstallationsByDate(this.form.controls.startDate.value, this.form.controls.endDate.value)
      .subscribe((list) => {
        this.idList = list;

        this.idList.forEach((el) => {
          this.idArray.push(el.ID_INSTALLATION)
        })

        this.loadIncidentsDatas();

      })

  }

  /**
   * Filter the list of Pannes on an array of Apds ids
   * @param pannes the Pannes object containing the list 
   * @param arr 
   * @returns 
   */
  computeInstallations( arr: number[] ): void {
    this.installations = this.installations.filter(function (el) {
      if (arr.includes(el.id_installation)) {
        return el.id_installation;
      } else {
        return null;
      }
    })
    this.isLoading = false;
  }
}
